var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDeleteIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 30,
    viewBox: "0 0 29 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.546875 7.45267C0.546875 6.76688 1.07644 6.21094 1.7297 6.21094H27.0004C27.6537 6.21094 28.1832 6.76688 28.1832 7.45267C28.1832 8.13846 27.6537 8.6944 27.0004 8.6944H1.7297C1.07644 8.6944 0.546875 8.13846 0.546875 7.45267Z",
    fill: "#40C706"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.5399 29.5148C16.0888 29.7485 12.6238 29.8361 9.17276 29.8946C8.93619 29.8946 8.50481 29.9092 8.26825 29.9092C6.22265 29.9676 4.34405 28.2438 4.13532 26.0963C4.10749 25.8772 4.10749 25.6289 4.10749 25.4097C4.07965 19.5809 4.06574 13.2554 4.14923 7.44116C4.23273 5.83422 6.41747 5.81961 6.51488 7.44116C6.59838 13.2554 6.59838 19.5809 6.55663 25.4097C6.54271 25.7457 6.57054 26.1109 6.72362 26.4177C7.00193 27.0313 7.62813 27.4403 8.26825 27.4403C8.50481 27.4403 8.93619 27.4549 9.17276 27.4549C12.6377 27.5134 16.0888 27.601 19.5399 27.8348C20.5279 27.9224 20.5418 29.4271 19.5399 29.5148Z",
    fill: "#40C706"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.4094 6.21094C24.0626 6.21094 24.5922 6.76688 24.5922 7.45267V24.3548C24.5922 25.0406 24.0626 25.5965 23.4094 25.5965C22.7561 25.5965 22.2266 25.0406 22.2266 24.3548V7.45267C22.2266 6.76688 22.7561 6.21094 23.4094 6.21094Z",
    fill: "#40C706"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.3888 2.57331C10.7201 2.57331 10.1782 3.14223 10.1782 3.84425V7.45258C10.1782 8.13837 9.64858 8.69431 8.99533 8.69431C8.34207 8.69431 7.8125 8.13837 7.8125 7.45258V3.84425C7.8125 1.77065 9.41357 0.0898438 11.3888 0.0898438H17.3447C19.3199 0.0898438 20.921 1.77065 20.921 3.84425V7.43797C20.921 8.12376 20.3914 8.6797 19.7382 8.6797C19.0849 8.6797 18.5553 8.12376 18.5553 7.43797V3.84425C18.5553 3.14223 18.0134 2.57331 17.3447 2.57331H11.3888Z",
    fill: "#40C706"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.2453 11.1211C11.8986 11.1211 12.4282 11.677 12.4282 12.3628V23.3923C12.4282 24.0781 11.8986 24.634 11.2453 24.634C10.5921 24.634 10.0625 24.0781 10.0625 23.3923V12.3628C10.0625 11.677 10.5921 11.1211 11.2453 11.1211Z",
    fill: "#40C706"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.4797 11.1211C18.133 11.1211 18.6625 11.677 18.6625 12.3628V23.3923C18.6625 24.0781 18.133 24.634 17.4797 24.634C16.8264 24.634 16.2969 24.0781 16.2969 23.3923V12.3628C16.2969 11.677 16.8264 11.1211 17.4797 11.1211Z",
    fill: "#40C706"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteIcon);
export default __webpack_public_path__ + "static/media/deleteIcon.4cae02b233447e17dc10eb25f3aeaa26.svg";
export { ForwardRef as ReactComponent };